import StyleSelect from "../../../components/Button/AutoComplete";
import StyleInput from "../../../components/Button/Input";
import DiscountInput from "./DiscountInput";
import { parseDesc } from "../../../env";
import tabletrans from "../../../translate/tables";
import PostReq from "../../../utils/PostReq";
import { Autocomplete, TextField } from "@mui/material";
import { useState, useEffect } from "react";

function ProductSKU(props) {
  const content = props.content;
  const def = content ? content.filter : "";
  const brand = content && content.brandList;
  const category = content && content.categoryList;
  const filterList = content && content.filterList;
  const [productList, setProductList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  useEffect(() => {
    if (!searchText) {
      setProductList([]);
      return;
    }

    const delay = setTimeout(() => {
      fetchProducts(searchText);
    }, 500); // 500ms debounce

    return () => clearTimeout(delay);
  }, [searchText]);

  const removeMaster = async () => {
    const result = await PostReq({
      method: "Post",
      url: "/panel/product/editProduct",
      body: { productId: def._id, masterSku: "" },
    });
    window.location.reload();
  };
  // const fetchProducts = async (search) => {
  //   const result = await PostReq({
  //     method: "Post",
  //     url: "/panel/product/list-product",
  //     body: { title: search, pageSize: "10", offset: "0" },
  //   });
  //   setProductList(result.filter);
  // };
  // console.log(content);
  const fetchProducts = async (search) => {
    setLoading(true);
    try {
      const result = await PostReq({
        method: "Post",
        url: "/panel/product/list-product",
        body: {
          title: search,
          pageSize: "10",
          offset: "0",
        },
      });

      setProductList(result?.filter || []);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="pd-row">
      <div className="row-title">
        <h4>{tabletrans.propertie[props.lang]}</h4>
        <p>{tabletrans.attributes[props.lang]}</p>
      </div>
      <div className="row-box">
        <div className="probs-wrapper">
          <div className="input-wrapper">
            {/*<StyleInput title={tabletrans.productCode[props.lang]} direction={props.direction}
                 class={"formInput"} defaultValue={def?def.productCode:''} 
                 action={(e)=>props.setProductChange(prevState => ({
                    ...prevState,
                    productCode:e
                  }))}/>*/}
            <StyleInput
              title={tabletrans.productSku[props.lang]}
              direction={props.direction}
              class={"formInput"}
              defaultValue={def ? def.sku : ""}
              action={(e) =>
                props.setProductChange((prevState) => ({
                  ...prevState,
                  sku: e,
                }))
              }
            />

            {!content?.filter?.isMaster && (
              <DiscountInput
                title="تخفیف سایت(درصد)"
                direction={props.direction}
                class="formInput"
                defaultValue={def?.siteDiscount ?? ""}
                action={(value) =>
                  props.setProductChange((prevState) => ({
                    ...prevState,
                    siteDiscount: value,
                  }))
                }
              />
            )}
            {/*<StyleInput title={tabletrans.quantity[props.lang]} direction={props.direction}
                 class={"formInput"} defaultValue={content?content.quantity:''} 
                 action={(e)=>props.setProductChange(prevState => ({
                    ...prevState,
                    quantity:e
                  }))}/>*/}
            <StyleSelect
              title="محصول اصلی"
              direction={props.direction}
              class={"formInput halfWidth"}
              defaultValue={
                content && content.filter.isMaster
                  ? { title: "بلی", value: 1 }
                  : { title: "خیر", value: 0 }
              }
              options={[
                { title: "بلی", value: 1 },
                { title: "خیر", value: 0 },
              ]}
              label={"title"}
              action={(e) =>
                props.setProductChange((prevState) => ({
                  ...prevState,
                  isMaster: e ? e.value : 0,
                }))
              }
            />
            {/* <StyleSelect
              title="رزرو شده"
              direction={props.direction}
              class={"formInput halfWidth"}
              defaultValue={
                content && content.filter.isReserve
                  ? { title: "بلی", value: true }
                  : { title: "خیر", value: false }
              }
              options={[
                { title: "بلی", value: true },
                { title: "خیر", value: false },
              ]}
              label={"title"}
              action={(e) =>
                props.setProductChange((prevState) => ({
                  ...prevState,
                  isReserve: e ? e.value : false,
                }))
              }
            /> */}
            <StyleSelect
              title={tabletrans.category[props.lang]}
              direction={props.direction}
              class={"formInput halfWidth"}
              defaultValue={def ? def.categories : []}
              options={category ? category : []}
              label="title"
              multiSelect={true}
              action={(e) =>
                props.setProductChange((prevState) => ({
                  ...prevState,
                  categories: e,
                }))
              }
            />
            <Autocomplete
              multiple
              options={productList}
              loading={loading}
              filterOptions={(x) => x} // جلوگیری از فیلتر داخلی
              getOptionLabel={(option) => option?.title || ""}
              isOptionEqualToValue={(opt, val) => opt.sku === val.sku}
              defaultValue={content?.similarName || []}
              onChange={(event, value) =>
                props.setProductChange((prev) => ({
                  ...prev,
                  similar: value.map((item) => item.sku),
                }))
              }
              onInputChange={(event, value) => {
                setSearchText(value);
              }}
              sx={{ minWidth: 300 }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="محصول مشابه"
                  variant="outlined"
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <>
                        {loading ? "در حال جستجو..." : null}
                        {params.InputProps.endAdornment}
                      </>
                    ),
                  }}
                />
              )}
            />
            <StyleInput
              title={"اولویت"}
              direction={props.direction}
              class={"formInput"}
              defaultValue={def ? def.sort : ""}
              action={(e) =>
                props.setProductChange((prevState) => ({
                  ...prevState,
                  sort: e,
                }))
              }
            />
            <StyleSelect
              title="محصول وبسایت"
              direction={props.direction}
              class={"formInput halfWidth"}
              defaultValue={[
                { title: "نیست", value: 0 },
                { title: "1", value: 1 },
                { title: "2", value: 2 },
                { title: "3", value: 3 },
                { title: "4", value: 4 },
                { title: "5", value: 5 },
                { title: "6", value: 6 },
                { title: "7", value: 7 },
                { title: "8", value: 8 },
              ].find(
                (item) => item.value === (content?.filter?.selectedIndex ?? 0),
              )}
              options={[
                { title: "نیست", value: 0 },
                { title: "1", value: 1 },
                { title: "2", value: 2 },
                { title: "3", value: 3 },
                { title: "4", value: 4 },
                { title: "5", value: 5 },
                { title: "6", value: 6 },
                { title: "7", value: 7 },
                { title: "8", value: 8 },
              ]}
              label={"title"}
              action={(e) =>
                props.setProductChange((prevState) => ({
                  ...prevState,
                  selectedIndex: e ? e.value : 0,
                }))
              }
            />
            {filterList &&
              filterList.map((filter, i) => (
                <StyleSelect
                  title={filter.title}
                  direction={"rtl"}
                  class={"formInput halfWidth"}
                  key={i}
                  defaultValue={
                    def && def.filters ? def.filters[filter.enTitle] : ""
                  }
                  options={filter ? filter.optionsP : []}
                  label="title"
                  action={(e) =>
                    props.setFilters((data) => ({
                      ...data,
                      [filter.enTitle]: e,
                    }))
                  }
                />
              ))}
            {content?.filter?.masterSku && (
              <div
                className="save-btn"
                style={{ backgroundColor: "darkRed", margin: "15px" }}
                onClick={removeMaster}
              >
                حذف اتصال به محصول اصلی
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
export default ProductSKU;
